import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './FullScreenModalLayoutFooter.st.css';
import { FullScreenModalLayoutFooterProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutFooter = ({
  children,
  dataHook,
  className,
}: FullScreenModalLayoutFooterProps) => {
  return (
    <div
      data-hook={dataHook || DATA_HOOKS.fullScreenModalLayoutFooter}
      className={st(classes.root, {}, className)}
    >
      {children}
    </div>
  );
};

FullScreenModalLayoutFooter.displayName = 'FullScreenModalLayout.Footer';

FullScreenModalLayoutFooter.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook: PropTypes.string,
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   **/
  className: PropTypes.string,
  /** Footer node */
  children: PropTypes.node.isRequired,
};

export default FullScreenModalLayoutFooter;
